// Copyright aptihealth, inc. 2019 All Rights Reserved
import * as actionTypes from "../actions/actionTypes";

let initialState = {
  cardToken: undefined,
  expirationDate: undefined,
  isPaymentUpdateRequired: undefined,
  isSoftPaywall: undefined,
  lastFailedChargeDate: undefined,
  lastFourDigits: undefined,
  patientCardLoaded: false,
  showPaywall: undefined,
  username: undefined,
};

export const patientCardInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_PATIENT_CARD_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.UPDATE_PATIENT_PAYWALL_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.LOG_OUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
